<template>
  <footer class="provider-footer">
    <span>Tecnología de</span>
    <a href="https://www.buiran.com" target="_blank" rel="noopener" aria-label="Buiran, proveedor tecnológico. Visitar www.buiran.com">
      <img :src="logo" alt="Buiran" width="32" height="26" />
    </a>
    <a href="https://www.buiran.com" target="_blank" rel="noopener" class="provider-website">www.buiran.com</a>
  </footer>
</template>
<script>
import logo from "../assets/brand/buiran.svg";
export default { data() { return { logo }; } };
</script>
<style scoped>
.provider-footer { position: fixed; inset: auto 0 0; z-index: 30; display: grid; grid-template-columns: minmax(0, 1fr) 32px minmax(0, 1fr); align-items: center; gap: 8px; min-height: calc(44px + env(safe-area-inset-bottom, 0px)); padding: 0 12px env(safe-area-inset-bottom, 0px); background: white; border-top: 1px solid #e0e6e4; color: #687780; font-size: 11px; }
.provider-footer > span { text-align: right; }
.provider-footer a { display: flex; align-items: center; gap: 8px; min-height: 44px; text-decoration: none; color: #37474f; }
.provider-footer img { display: block; object-fit: contain; }
.provider-footer a:hover { text-decoration: underline; }
</style>
